import HttpClient from './HttpClient';

const ConversacionesService = {
  getTiposPersona: () => {
    const path = 'conversacion/pregunta/tipo-persona';
    return HttpClient.get(path, {}, true);
  },
  getPreguntas: (id) => {
    const path = 'conversacion/pregunta/' + id + '/preguntas';
    return HttpClient.get(path, {}, true);
  },
  deletePregunta: (id) => {
    const path = 'conversacion/pregunta/' + id;
    return HttpClient.delete(path, {}, true);
  },
  changeOrder: (id, order) => {
    const path = 'conversacion/pregunta/' + id + '/' + order;
    return HttpClient.post(path, {}, true);
  },
  crearPregunta: (data) => {
    const path = 'conversacion/pregunta';
    return HttpClient.post(path, data, true);
  },
  solicitarInicioConverasion: (idExpediente, type) => {
    const path = `conversacion/formulario/${idExpediente}/${type}/inicio`;
    return HttpClient.post(path, {}, true);
  },
  getConverasion: (idExpediente, type, phone) => {
    const path = `conversacion/respuestas/${idExpediente}/${type}/${phone}`;
    return HttpClient.get(path, {}, true);
  }
};
export default ConversacionesService;
